<template>
  <el-container :class="pageClass">
    <el-header v-if="token != ''">
      <top-bar ref="top" :menu="topRouters" />
    </el-header>
    <div v-if="token != ''" class="dni-aside">
      <el-scrollbar class="frame-scrollbar menu-scrollbar">
        <el-menu
          :default-active="$route.path"
          mode="vertical"
          router
          unique-opened
          class="left-menu"
          @select="menuSelect"
        >
          <sidebar-item :menu="getrouters" :parent="$store.state.page.topSelectedMenu" />
        </el-menu>
        <app-link />
      </el-scrollbar>
    </div>

    <div v-if="token != ''" class="dni-main">
      <div v-if="$store.state.user.changing_lang" class="lang-switch">
        <div v-if="$store.state.user.change_lang_stage == 'confirm'">
          <el-divider />
          <div class="lang-switch-tip">
            {{ $t("ml_switch") }} <b>{{ utils.getLanguageShow($store.state.user.gui_region) }}</b>
            {{ $t("ml_curlang") }}
            <b>{{ utils.getLanguageShow($store.state.user.user_gui_region) }}</b> ?
          </div>
          <el-divider />
          <div class="lang-buttons">
            <el-button :id="yes" @click="clickYes">
              {{ $t("yes_mark") }}
            </el-button>
            <el-button :id="no" @click="clickNo">
              {{ $t("no_mark") }}
            </el-button>
          </div>
        </div>
      </div>
      <div v-else>
        <router-view :key="timestamp" />
      </div>
      <div
        v-if="$store.state.page.loading && !$store.state.page.isProcessLoading"
        :id="utils.getIds('common', 'pls_wait_icon')"
        class="el-loading-mask"
      >
        <div id="wait_img" class="dni-page-loading">
          <div id="wait_text">{{ $t("wizard_pls_wait") }}</div>
          <img src="~images/wizard/wait.gif" />
        </div>
      </div>
      <div
        v-else-if="$store.state.page.loading && $store.state.page.isProcessLoading"
        class="el-loading-process"
        :class="$store.state.page.loadingClass"
      >
        <div id="prgbar1" class="process-bar">
          <div
            id="process"
            :style="{ width: $store.state.page.process + '%' }"
            class="process"
          ></div>
        </div>
      </div>
      <div v-else-if="$store.state.user.change_lang_stage == 'process'">
        <div class="el-loading-process" :class="$store.state.page.loadingClass">
          <div class="lang-switch-tip wait_update_lang">{{ $t("wait_update_lang") }}</div>
          <div id="prgbar1" class="process-bar">
            <div
              id="Loading"
              :style="{ width: $store.state.page.process + '%' }"
              class="process"
            ></div>
          </div>
        </div>
      </div>
      <dni-footer />
    </div>
    <armor v-if="inited" />
  </el-container>
</template>

<script>
import _ from "@/plugins/lodash";
import { commontRouterMap } from "@/router";
import { logWithPrefix } from "@/plugins/logging";
import TopBar from "@/components/header/topBar";
import DniFooter from "@/components/footer/dniFooter.vue";
import SidebarItem from "@/components/header/sidebarItem";
import Armor from "@/components/form/armor";
import AppLink from "@/components/form/appLink";
const log = logWithPrefix("[layouts/default.vue]");
export default {
  name: "Layout",
  components: { TopBar, DniFooter, SidebarItem, Armor, AppLink },
  data() {
    return {
      timestamp: this.generateTs(),
      inited: false,
      token: "",
    };
  },
  computed: {
    getrouters() {
      let topMenu = "/basic";
      if (_.startsWith(this.$route.path, "/adv")) {
        topMenu = "/adv";
      }
      this.$store.dispatch("page/setTopMenu", topMenu);
      const menus = commontRouterMap.find((o) => o.path === topMenu);
      if (menus) {
        return menus.children;
      }
      return [];
    },
    topRouters() {
      return commontRouterMap.filter((o) => o.isTopMenu);
    },
    pageClass() {
      let classNames = [this.$store.state.user.device_mode + "-mode"];
      if (this.$store.state.page.type) {
        classNames.push(this.$store.state.page.type);
      }
      if (this.$store.state.page.style) {
        classNames.push(this.$store.state.page.style);
      }
      if (this.$route.name) {
        classNames.push(this.$route.name + "-page");
      }
      return classNames.join(" ");
    },
  },
  async beforeCreate() {
    // 此处为解决直接输入http://[IP]/#/basic/home，无法快速跳转login页面的问题
    this.$store.dispatch("page/setLoading", false);
    this.$store.dispatch("page/setLoadingStyle", false, 0, "");
    this.$store.state.user.changing_lang = false;
    this.$store.state.user.change_lang_stage = "";
    this.token = await this.$store.dispatch("user/getToken");
    if (!this.token) {
      this.utils.routerReplace2("login", this.$route.path);
      return;
    }
    const ret = await this.$store.dispatch("user/getinfo");
    if (ret && ret.code == 0) {
      this.inited = true;
    }
  },
  watch: {
    $route: {
      handler(newValue, oldValue) {
        log(oldValue, ">", newValue);
        if (newValue && _.startsWith(newValue.path, "/adv")) {
          this.$store.dispatch("page/setTopMenu", "/adv");
        } else {
          this.$store.dispatch("page/setTopMenu", "/basic");
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.$store.dispatch("user/loadLocaleLanguage");
  },
  methods: {
    clickYes() {
      this.$refs.top.$refs.lang.switchLang();
    },
    clickNo() {
      this.$refs.top.$refs.lang.cancelChangeLang();
    },
    generateTs() {
      return new Date().toLocaleString();
    },
    menuSelect() {
      if (this.$route.params) {
        const path = this.$route.path;
        this.$router.replace("/");
        this.$router.replace(path);
      }
      this.timestamp = this.generateTs();
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.el-container {
  min-width: $pageMiniWidth - 10px;
}
.dni-aside {
  width: $leftMenuWidth;
  position: absolute;
  top: $toBarHeight;
  left: 0;
  bottom: $footerHeight;
  min-height: $minMainHeight;
  background-color: $pagebgColor;
  padding-left: $leftMenuToLeft;
}
.dni-main {
  position: absolute;
  top: $toBarHeight;
  left: $leftMenuWidth - $frameBorderWidth + $leftMenuToLeft;
  right: 0;
  bottom: $footerHeight;
  border-left: solid $frameBorderWidth $frameBorderColor;
  min-width: $pageMiniWidth - $leftMenuWidth + $frameBorderWidth - $leftMenuToLeft;
  min-height: $minMainHeight;
  background-color: $pagebgColor;

  .lang-switch {
    width: calc(100% - 20px);
    .lang-switch-tip {
      padding: 20px;
    }
    .lang-buttons {
      margin-top: 40px;
      text-align: center;
    }
  }
}
.dni-footer {
  min-width: $pageMiniWidth - $leftMenuToLeft * 2;
}

// Same specail page need to define different the min-width
$attachedMainWidth: 875px;
.attached-page {
  .dni-main {
    min-width: $attachedMainWidth;
  }
  .top-bar,
  .dni-footer {
    min-width: $attachedMainWidth + $leftMenuWidth + $leftMenuToLeft * 2;
  }
}
.advHome-page,
.status-page {
  .dni-main {
    min-width: $advHomeMainWidth;
    min-height: $advHomeMainHeight;
  }
  .dni-aside {
    min-height: $advHomeMainHeight;
  }
  .top-bar,
  .dni-footer {
    min-width: $advHomeMainWidth + $leftMenuWidth + $leftMenuToLeft * 2;
  }
}
.bridge-mode.advHome-page .dni-main,
.bridge-mode.advHome-page .dni-aside,
.bridge-mode.advHome-page .top-bar {
  min-width: unset;
  min-height: unset;
}
.dni-page-loading {
  width: 100%;
  text-align: center;
  position: absolute;
  padding-top: 20px;
  line-height: 50px;
}
.orbi.gui-2-1 {
  .dni-main {
    border-left: 0 none;
  }
}
</style>
<style lang="scss" scoped>
.wait_update_lang {
  padding: 0 20px 30px 20px;
}
</style>
